import { getUserLocal } from "./localStorage.util";

export const ROUTE_PERMISSIONS = {
  "/dashboard": "dashboard.view",
  "/e-paper": "epaper.view",
  "/add-epaper": "epaper.create",
  "/edit-epaper": "epaper.edit",
  "/view-epaper/pages": "epaper.view",
  "/edit-page": "epaper.edit",
  "/staff": "staff.view",
  "/add-staff": "staff.create",
  "/edit-staff": "staff.edit",
  "/roles": "roles.view",
  "/add-role": "roles.create",
  "/edit-role": "roles.edit",
};

const DEFAULT_ROUTE = "/profile";

export const getUserPermissions = (user = getUserLocal()) => {
  if (!user) return [];
  if (user.isSuperAdmin) return ["*"];
  return user.role?.permissions || [];
};

export const hasPermission = (permission, user = getUserLocal()) => {
  if (!permission) return true;
  const permissions = getUserPermissions(user);
  return permissions.includes("*") || permissions.includes(permission);
};

export const getFirstAllowedRoute = (user = getUserLocal()) => {
  const firstAllowed = Object.entries(ROUTE_PERMISSIONS).find(([, permission]) =>
    hasPermission(permission, user)
  );

  return firstAllowed?.[0] || DEFAULT_ROUTE;
};
